// Which of getPrice's prices a customer may get.
//
// getPrice answers every price of the slot, member prices included, each member price tagged with
// its membershipid. The client keeps a member price only for a membership the customer holds. The
// list to check against is, in order:
//   - a company booking: the organisation's memberships;
//   - `served`: the memberships getPrice itself answered with (ui-get, falcon
//     feat/getprice-memberships). It is worked out with the prices, so it cannot lag them;
//   - the redux copy of users/{uid}/memberships/active/{customerid}.
// The redux copy alone was the bug behind "full price although I have a membership": a checkout
// opened before the Firestore listener had delivered priced against an empty list, dropped every
// member price, and never priced again.

const idsOf = (source) => {
  if (Array.isArray(source)) return source.filter(Boolean).map((m) => m.membershipid).filter(Boolean)
  return Object.keys(source || {})
    .map((key) => source[key] && source[key].membershipid)
    .filter(Boolean)
}

export const membershipIdsFor = ({ served, memberships, isBusiness, orgMemberships }) => {
  if (isBusiness) return idsOf(orgMemberships || [])
  return idsOf(served || memberships)
}

// The prices the customer may get, cheapest first. General prices (no membershipid) always stay.
export const allowedPrices = (prices, membershipids) =>
  (Array.isArray(prices) ? prices.slice() : [])
    .filter((p) => p && (!p.membershipid || membershipids.includes(p.membershipid)))
    .sort((a, b) => a.price - b.price)

// A stable key for the customer's membership list, to price again when it changes (the list
// arriving after the first getPrice). '' while there are none.
export const membershipKey = (memberships) => idsOf(memberships).sort().join(',')
